/** Identité du commerçant reprise sur le contrat de partenariat (FR + DE). */

export const MERCHANT_LEGAL_FORMS = [
  { code: 'ei', fr: 'Entreprise individuelle', de: 'Einzelunternehmen', en: 'Sole proprietorship', it: 'Ditta individuale' },
  { code: 'sarl', fr: 'Sàrl', de: 'GmbH', en: 'LLC (Sàrl)', it: 'Sagl' },
  { code: 'sa', fr: 'SA', de: 'AG', en: 'Ltd (SA)', it: 'SA' },
  { code: 'snc', fr: 'Société en nom collectif', de: 'Kollektivgesellschaft', en: 'General partnership', it: 'Società in nome collettivo' },
  { code: 'association', fr: 'Association', de: 'Verein', en: 'Association', it: 'Associazione' },
  { code: 'other', fr: 'Autre', de: 'Andere', en: 'Other', it: 'Altro' },
] as const;

export const MERCHANT_SIGNATORY_FUNCTIONS = [
  { code: 'owner', fr: 'Titulaire', de: 'Inhaber', en: 'Owner', it: 'Titolare' },
  { code: 'manager', fr: 'Gérant', de: 'Geschäftsführer', en: 'Manager', it: 'Gerente' },
  { code: 'partner', fr: 'Associé', de: 'Gesellschafter', en: 'Partner', it: 'Socio' },
  { code: 'director', fr: 'Administrateur', de: 'Verwaltungsrat', en: 'Director', it: 'Amministratore' },
  { code: 'other', fr: 'Autre', de: 'Andere', en: 'Other', it: 'Altro' },
] as const;

export type MerchantLegalFormCode = (typeof MERCHANT_LEGAL_FORMS)[number]['code'];
export type MerchantSignatoryFunctionCode = (typeof MERCHANT_SIGNATORY_FUNCTIONS)[number]['code'];

const LEGAL_FORM_CODES = new Set<string>(MERCHANT_LEGAL_FORMS.map((item) => item.code));
const SIGNATORY_CODES = new Set<string>(MERCHANT_SIGNATORY_FUNCTIONS.map((item) => item.code));

export function isMerchantLegalFormCode(value: string): value is MerchantLegalFormCode {
  return LEGAL_FORM_CODES.has(value);
}

export function isMerchantSignatoryFunctionCode(value: string): value is MerchantSignatoryFunctionCode {
  return SIGNATORY_CODES.has(value);
}

function labelFor(
  list: readonly { code: string; fr: string; de: string }[],
  code: string | null | undefined,
  detail: string | null | undefined,
  lang: 'fr' | 'de',
): string {
  const trimmed = code?.trim() ?? '';
  if (!trimmed) return '';
  if (trimmed === 'other') return detail?.trim() ?? '';
  const item = list.find((entry) => entry.code === trimmed);
  return item ? item[lang] : '';
}

export function merchantLegalFormLabel(
  code: string | null | undefined,
  detail: string | null | undefined,
  lang: 'fr' | 'de',
): string {
  return labelFor(MERCHANT_LEGAL_FORMS, code, detail, lang);
}

export function merchantSignatoryFunctionLabel(
  code: string | null | undefined,
  detail: string | null | undefined,
  lang: 'fr' | 'de',
): string {
  return labelFor(MERCHANT_SIGNATORY_FUNCTIONS, code, detail, lang);
}
